module.exports = __webpack_public_path__ + "img/kx5600-2.49452bd1.png";